module.exports = __webpack_public_path__ + "static/media/spin_cash50.d70da1d7.png";